<template>
  <div>
    <Drawer
      :title="changeModalTitle"
      v-model="changeModal"
      width="600"
      @on-cancel="formReset"
      :mask-closable="true">
      <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
      <Form :model="changeForm" ref="changeForm" :rules="changeRule" label-position="right">
        <FormItem prop="name" label="网络名称">
          <Input v-model="changeForm.name" placeholder="填写网络名称" :maxlength="128" />
        </FormItem>
        <FormItem label="供应商网络类型" v-if="!changeForm.id">
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>实现虚拟网络的物理机制。</p>
            </div>
          </tooltip>
          <Select v-model="changeForm['provider:network_type']" clearable placeholder="">
            <Option value="local" key="local" disabled>Local</Option>
            <Option value="flat" key="flat">Flat</Option>
            <Option value="vlan" key="vlan">VLAN</Option>
            <Option value="gre" key="gre">GRE</Option>
            <Option value="vxlan" key="vxlan">VXLAN</Option>
            <Option value="geneve" key="geneve">Geneve</Option>
          </Select>
        </FormItem>
        <FormItem label="物理网络" v-if="changeForm['provider:network_type'] === 'flat' || changeForm['provider:network_type'] === 'vlan'">
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>虚拟网络对应的物理网络的名称。指定一个在neutron环境中定义的物理网络。</p>
            </div>
          </tooltip>
          <Input v-model="changeForm['provider:physical_network']" />
        </FormItem>
        <FormItem label="段ID" v-if="changeForm['provider:network_type'] !== 'local' && changeForm['provider:network_type'] !== 'flat' && changeForm['provider:network_type']">
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>对于 geneve 网络，有效ID为 1 到 16777215. </p>
              <p>对于 vlan 网络，有效ID为 1 到 4094.</p>
              <p>对于 gre 网络，有效ID为 1 到 4294967295. </p>
              <p><span>对于 vxlan 网络，有效ID为 1 到 16777215.</span></p>
            </div>
          </tooltip>
          <InputNumber :min="1" v-model="changeForm['provider:segmentation_id']" style="margin-left: 10px" />
        </FormItem>
        <FormItem label="外部网络">
          <div style="float: left">
            <i-switch v-model="changeForm['router:external']">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </FormItem>
        <FormItem label="共享的">
          <div style="float: left">
            <i-switch v-model="changeForm.shared">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </FormItem>
        <FormItem label="成功后创建子网" v-if="!changeForm.id">
          <div style="float: left">
            <i-switch v-model="changeForm.create_subnet">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </FormItem>
        <FormItem label="活跃状态">
          <tooltip placement="right" transfer max-width="200" style="float: left">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>当网络的活跃状态开启，网络将会是可用的。</p>
              <p>如果您还没有准备让别人访问该网络，可以把活跃状态关闭。</p>
            </div>
          </tooltip>
          <div style="float: left; margin-left: 15px">
            <i-switch v-model="changeForm.admin_state_up">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
          <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>

<script>
import { changePrivateCloudNetwork } from '@/api/private-cloud/network'
export default {
  name: 'network-edit',
  data () {
    return {
      changeModalTitle: '创建网络',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        id: '',
        name: '',
        'provider:network_type': '',
        'provider:physical_network': '',
        'provider:segmentation_id': '',
        'router:external': false,
        admin_state_up: true,
        shared: false,
        create_subnet: true
      },
      changeRule: {
        name: [
          { required: true, message: '网络名称不能为空', trigger: 'blur' }
        ]
      },
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    // 打开创建模式
    openModal () {
      this.formReset()
      this.changeModalTitle = '创建网络'
      this.changeModal = true
    },
    // 打开修改模式
    modifyOpenModal (row) {
      this.formReset()
      this.changeForm.id = row.id
      this.changeForm.name = row.name
      this.changeForm['router:external'] = row['router:external']
      this.changeForm.shared = row.shared
      this.changeForm.admin_state_up = row.admin_state_up
      this.changeModalTitle = '[' + row.name + '] 编辑'
      this.changeModal = true
    },
    // 通用表单重置
    formReset () {
      this.changeForm = {
        id: '',
        name: '',
        'provider:network_type': '',
        'provider:physical_network': '',
        'provider:segmentation_id': '',
        admin_state_up: true,
        shared: false,
        create_subnet: true
      }
    },
    // 提交网络编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          if (this.changeForm['provider:network_type'] !== 'local' && this.changeForm['provider:network_type']) {
            if (!this.changeForm['provider:physical_network']) {
              if (this.changeForm['provider:network_type'] === 'flat' || this.changeForm['provider:network_type'] === 'vlan') {
                this.$Notice.error({ title: '请填写物理网络！' })
                return
              }
            }
            if (!this.changeForm['provider:segmentation_id']) {
              if (this.changeForm['provider:network_type'] !== 'flat') {
                this.$Notice.error({ title: '请填写段ID！' })
                return
              }
            }
          }
          this.changeLoading = true
          changePrivateCloudNetwork(this.changeForm, this.changeForm.id).then(res => {
            this.errorMsgShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('editComplete', res.data.network, !this.changeForm.id && this.changeForm.create_subnet)
            this.formReset()
            this.changeLoading = false
            this.changeModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！服务器无响应'
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
